const Section05 = ({
  contentsRef,
}: {
  contentsRef: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <section
      className='section05 w-full pb-[100px] bg-main-section03 bg-bottom bg-cover'
      ref={contentsRef}
    >
      <div className='max-w-[1080px] mx-auto pt-[120px] pb-[200px] relative'>
        <h3 className='text-[#6479E5] font-[600] mb-[12px] text-center'>
          그룹사
        </h3>
        <p className='text-[24px] leading-[38.4px] font-[600] text-white text-center'>
          한국영업경제인협회는 우리 모두의 지속 가능한
          <br />
          내일을 함께 만들어 대한민국 경제 발전에 이바지합니다.
        </p>
        <div className='w-full mt-[80px]'>
          <ul className='flex justify-center items-center'>
            <li className='p-[68px] border-[0.5px] border-[#FFFFFF4D] rounded-full mr-[-40px]'>
              <img
                src='/imgs/section03_item_img01.webp'
                alt=''
                className='w-[150px] h-[150px] object-contain'
              />
            </li>
            <li className='p-[68px] border-[0.5px] border-[#FFFFFF4D] rounded-full'>
              <img
                src='/imgs/section03_item_img02.webp'
                alt=''
                className='w-[150px] h-[150px] object-contain'
              />
            </li>
            <li className='p-[68px] border-[0.5px] border-[#FFFFFF4D] rounded-full ml-[-40px]'>
              <img
                src='/imgs/section03_item_img03.webp'
                alt=''
                className='w-[150px] h-[150px] object-contain'
              />
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
export default Section05;
